'use client';

import { getMembershipPrice } from '@/features/membership/internal/helper/get-membership-price';
import { useLocale } from 'next-intl';
import { LocaleCode } from '@/i18n/locales';
import { useCurrency } from '@/features/shared/hooks/use-currency';

export const MembershipPrice = () => {
  const currentCurrency = useCurrency();
  const currentLocale = useLocale() as LocaleCode;
  const price = getMembershipPrice(currentCurrency, currentLocale);

  return <>{price}</>;
};
